<template>
  <label class="tw:inline-flex tw:items-center tw:gap-2 tw:cursor-pointer" @click.stop>
    <input v-model="value" type="checkbox" class="tw:sr-only" />
    <div
      class="tw:flex tw:justify-center tw:items-center tw:border tw:border-white tw:rounded-xs tw:w-4 tw:h-4"
      :class="{ 'tw:bg-[#039ED0]': value }"
    >
      <IconsCheckMark v-if="value" class="tw:text-white" />
    </div>
  </label>
</template>

<script setup lang="ts">
const value = defineModel<boolean>({ default: false });
</script>
